/**
 * Created by mykurisu on 2017/8/2.
 */
const defaults = {
    listener_list_passed_init: false,
    listener_passed: null,
    listener_passed_list: [],
    listener_list_rejected_init: false,
    listener_rejected: null,
    listener_rejected_list: [],
    tab:0,
    url_data: null,
    listener_list_passed_upload: [],
    listener_list_rejected_upload: [],
    searchKeys: '',
}


export default (state=defaults, action) => {
    switch(action.type){
        case 'LISTENER_MANAGE_ID':
            return {...state, url_data: action.payload};
        case 'LISTENER_MANAGE_PASSED_INIT':
            return {...state, listener_passed: action.payload, listener_list_passed_init: true};
        case 'LISTENER_MANAGE_PASSED_APPEND':
            return {...state, listener_passed_list: action.payload};
        case 'LISTENER_MANAGE_REJECTED_INIT':
            return {...state, listener_rejected: action.payload, listener_list_rejected_init: true};
        case 'LISTENER_MANAGE_REJECTED_APPEND':
            return {...state, listener_rejected_list: action.payload};
        case 'LISTENER_MANAGE_BAR_FIRST':
            return {...state, tab: 0};
        case 'LISTENER_MANAGE_BAR_SEC':
            return {...state, tab: 1};
        case 'LISTENER_LIST_CHANGE_PASSED':
            return {...state, listener_list_passed_upload: action.payload};
        case 'LISTENER_LIST_CHANGE_REJECT':
            return {...state, listener_list_rejected_upload: action.payload};
        case 'LISTENER_LIST_PASSED_CLEAR':
            return {...state, listener_list_passed_upload: []};
        case 'LISTENER_LIST_REJECTED_CLEAR':
            return {...state, listener_list_rejected_upload: []};
        case 'LISTENER_SEARCH':
            return {...state, searchKeys: action.payload}
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/listenermanage.js